angular.module('dashboard').controller('DashboardCtrl',
    ['$scope', '$uibModal', 'DashboardService', 'MyChartService', 'PatientPortalStorageRepository', 'ApPersonalHealthAppsModalService',
        function ($scope, $modal, DashboardService, MyChartService, PatientPortalStorageRepository, ApPersonalHealthAppsModalService) {
            'use strict';

            $scope.loading = true;
            $scope.showLinkPersonalHealthApp = true;

            $scope.today = new Date();

            var baseId = 'dashboard';
            var isPatientRegisteredForFHIR = false;
            var patientId = '';

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                var activePatient = PatientPortalStorageRepository.getActivePatient();
                patientId = activePatient.id;
                isPatientRegisteredForFHIR = false;

                $scope.activeTiles = _(DashboardService.getPatientDashboardFeatures())
                    .filter('IsActive')
                    .sortBy('DisplayOrder')
                    .value();

                MyChartService.getDetails(activePatient.id)
                    .then(function (data) {
                        $scope.patient = {
                            userId: activePatient.id,
                            name: activePatient.fullName,
                            birthDate: data.DateOfBirth,
                            providerName: data.PrimaryProviderName,
                            serviceSite: data.PrimaryProviderServiceSite,
                            serviceSitePhoneNumber: data.PrimaryProviderServiceSitePhoneNumber,
                            serviceSiteAddress1: data.PrimaryProviderServiceSiteAddress1,
                            serviceSiteAddress2: data.PrimaryProviderServiceSiteAddress2,
                            serviceSiteLocation: data.PrimaryProviderServiceSiteLocation
                        };
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
            loadPage();
            $scope.showPersonalHealthAppModal = showPersonalHealthAppModal;

            var notificationListener = $scope.$on('Notification:updated', function () {
                loadPage();
            });

            $scope.$on('$destroy', function () {
                notificationListener();
            });

            function showPersonalHealthAppModal() {
                ApPersonalHealthAppsModalService.openModal(baseId, patientId, isPatientRegisteredForFHIR)
                    .then(function(result) {
                        if (result.isSuccess) {
                            isPatientRegisteredForFHIR = result.resultValue;
                        }
                    });
            }
        }
    ]
);